export default __webpack_public_path__ + "static/media/FAQ_11_5.e5fc6001.png";